import { environment } from '$environments/environment';
import { UserDisplay } from '$types';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private horsesUrl: string = environment.apiUrl + '/rest/users';
  constructor(private readonly http: HttpClient) { }

  search(search: string): Observable<UserDisplay[]> {
    const has_correct_search = search.trim().length>3;
    if (!has_correct_search) return of([]);
    return this.http
      .get<UserDisplay[]>(`${this.horsesUrl}?search=${search.trim()}`)
  }
}
